import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgramMembershipsBackend {
  v3 = {
    getProgramMembershipToken: (token: string) =>
      this.http.get(`api/v3/program-membership/${token}`),
  };

  constructor(private http: HttpClient) {}
}
